import Vue from 'vue'
import VueRouter from 'vue-router';
import login from '../components/login.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/Welcome.vue'
import Department from '../components/department/Department.vue'
import Company from '../components/company/Company.vue'
import SalaryList from '../components/salary/SalaryList'
import SalaryUpload from '../components/salary/SalaryUpload'
import SalaryDetails from '../components/salary/SalaryDetails'
import Explain from '../components/config/Explain'
import IdentityCardApply from '../components/apply/IdentityCardApply'
import Order from '../components/order/Order.vue'

import Users from '../components/user/Users.vue'
import Rights from '../components/power/Rights.vue'
import Roles from '../components/power/Roles.vue'
import Cate from '../components/goods/Cate.vue'
import AddGoods from '../components/goods/AddGoods.vue'
import EditGoods from '../components/goods/EditGoods.vue'
import List from '../components/goods/List.vue'
import Params from '../components/goods/Params.vue'
import Report from '../components/report/Report.vue'

Vue.use(VueRouter)


const routes =[
    {
      path: '/login',
      component: login
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      component: Home,
      redirect: '/welcome',
      children: [
        {path :'/Welcome', component: Welcome},
        {path :'/department', component: Department},
        {path :'/company', component: Company},
        {path :'/salary/salaryList', component: SalaryList},
        {path :'/salary/salaryUpload', component: SalaryUpload},
        {path :'/salary/salaryDetails/:id', component: SalaryDetails,props:true},
        {path :'/config/explain', component: Explain},
        {path :'/apply/identityCardApply', component: IdentityCardApply},
        {path :'/order', component: Order},
        // {path: '/users', component: Users},
        // {path :'/rights',component: Rights},
        // {path :'/roles',component: Roles},
        // {path :'/categories', component: Cate},
        // {path :'/goods/add',component: AddGoods},
        // {path :'/goods/edit/:goodsId',component: EditGoods},
        // {path :'/goods',component: List},
        // {path :'/params',component: Params},
        // {path :'/orders',component: Order},
        // {path :'/reports',component: Report}

      ]
    }
  ]
const router =  new VueRouter({
  routes
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // 访问登录页，放行
  if (to.path === '/login') return next();
  // 获取token
  const tokenStr = window.localStorage.getItem('token')
  // 没有token, 强制跳转到登录页
  if (!tokenStr) return next('/login')
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js